import fluxHelper from './helper';
import fluxStepper from './stepper';
import fluxUI from './ui';

var fluxCoupon = {};

fluxCoupon.init = function() {
    this.onButtonClick();
    this.onFormSubmit();
    this.onChange();

    var sideBar = document.querySelector( '.flux-checkout--has-sidebar' );

    ( function ( $, document ) {
        $( document ).ready( function() {
            if ( sideBar ) {
                $( document.body ).on( 'wc_fragments_refreshed', function() {
                    fluxCoupon.onButtonClick();
                    fluxCoupon.onFormSubmit();
                } );

                $( document.body ).on( 'updated_checkout', function() {
                    fluxCoupon.onButtonClick();
                    fluxCoupon.onFormSubmit();
                } );
            }
        });
    }( jQuery, document ) );
};

/**
 * Login Buttons On Click.
 * 
 * Handle the show and hide of the login form from a custom button.
 */
fluxCoupon.onButtonClick = function() {
    var buttons = document.querySelectorAll( '[data-show-coupon]' );
    Array.from( buttons ).forEach( function( button ) {
        button.setAttribute( 'type', 'button' );
        button.addEventListener( 'click', function( e ) {
            e.preventDefault();

            var form = e.target.closest('.woocommerce-form-coupon__wrapper').querySelector( '.woocommerce-form-coupon' );

            if ( 'none' === form.style.display ) {
                fluxUI.slideDown( form );
            } else {
                fluxUI.slideUp( form );
            }
            
            return false;
        } ); 
    } );
};

fluxCoupon.onFormSubmit = function() {
    var buttons = document.querySelectorAll( 'button[name=apply_coupon]' );
    Array.from( buttons ).forEach( function( button ) {
        button.setAttribute( 'type', 'button' );
        button.addEventListener( 'click', async function( e ) {
            e.preventDefault();

            var form = e.target.closest('.woocommerce-form-coupon__wrapper');
            var row = form.querySelector( '.form-row' );
            var previousError = row.querySelector( '.error' );
            var previousSuccess = row.querySelector( '.success' );

            // Remove previous errors.
            if ( previousError ) {
                previousError.remove();
            }

            // Remove previous success.
            if ( previousSuccess ) {
                previousSuccess.remove();
            }

            var data = {
                action: 'apply_coupon',
                coupon_code: form.querySelector( 'input[name="coupon_code"]' ).value,
                security: wc_checkout_params.apply_coupon_nonce,
            };
            
            fluxStepper.loadSpinner();

            await fluxHelper.ajaxRequestWoo( data, function( response ) {
                var message = response.replace( /(<([^>]+)>)/gi, '' );
                
                if ( response.includes( 'woocommerce-error' ) ) {
                    row.classList.add( 'woocommerce-invalid' );

                    var error = document.createElement('div');
                    error.classList.add( 'error' );
                    error.setAttribute( 'aria-hidden', 'false' );
                    error.setAttribute( 'aria-live', 'polite' );
                    error.innerHTML = message;

                    row.appendChild( error );
                } else {
                    jQuery( document.body ).trigger( 'update_checkout', { update_shipping_method: false } );

                    row.classList.add( 'woocommerce-validated' );

                    var success = document.createElement('div');
                    success.classList.add( 'success' );
                    success.setAttribute( 'aria-hidden', 'false' );
                    success.setAttribute( 'aria-live', 'polite' );
                    success.innerHTML = message;

                    row.appendChild( success );
                }
    
            } );

            fluxStepper.removeSpinner();
            
            return false;
        } ); 
    } );
};

fluxCoupon.onChange = function () {
    jQuery( document ).on( 'keyup', '#coupon_code', function () {
        var $btn = jQuery( this ).closest( '.checkout_coupon' ).find( '.flux-coupon-button' );

        if ( jQuery( this ).val().trim() ) {
            $btn.removeClass( 'flux-coupon-button--disabled' );
        } else {
            $btn.addClass( 'flux-coupon-button--disabled' );
        }
    });
};

export default fluxCoupon;